import { BlankSlate } from "@msuite/ui/blank-slate";
import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { IncomingInvoiceDetail, Nullable } from "@msuite/utils/types";
import { FileCardRemote } from "@/components/files";

/** Props Interface */
interface IncomingInvoiceDocumentProps {
	incomingInvoice: Nullable<IncomingInvoiceDetail>;
}

/**
 * The document the invoice was read from, shown as the PDF itself so every field can be checked
 * against the page. Preview and download only: the file is the supplier's, and nothing here
 * unlinks or deletes it.
 */
export function IncomingInvoiceDocument({ incomingInvoice }: IncomingInvoiceDocumentProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Computed */
	const files = incomingInvoice?.files ?? [];

	/** Render */
	return (
		<ContentCard
			title={t("incoming_invoices.document")}
			icon={icon("FileText")}
			variant="plain"
		>
			{files.length ? (
				files.map((file) => (
					<FileCardRemote
						key={file.id}
						fileId={file.fileId}
						onInteraction={null}
						withRemove={false}
						variant="content-card"
					/>
				))
			) : (
				<BlankSlate
					label={t("incoming_invoices.no_document")}
					Icon={icon("FileText")}
				/>
			)}
		</ContentCard>
	);
}
